import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';

@Component({
  selector: 'app-generate-report',
  standalone: true,
  imports: [DxButtonModule],
  templateUrl: './generate-report.component.html',
  styleUrl: './generate-report.component.scss'
})
export class GenerateReportComponent {
 @Input() text: string = 'Generate';
  @Input() type: 'default' | 'success' | 'danger' | 'normal' = 'default';

  @Output() clicked = new EventEmitter<void>();

  handleClick() {
    this.clicked.emit();
  }
  }
